import { IStore } from '../index'

export const getEmployees = (state: IStore) => state.employees.employees
export const getEditEmployee = (state: IStore) => state.employees.editEmployee
export const getEmailError = (state: IStore) => state.employees.emailError
export const getEmployeeTab = (state: IStore) => state.employees.tab
export const getEmployeeLoading = (state: IStore) => state.employees.loading
